module.exports = __webpack_public_path__ + "img/example.952f549f.png";